/**
 * Display modes available for the Opportunity Stage field.
 *
 * `select` renders a dropdown, `meter` renders the progress-meter widget.
 */
export const OppStageIndicatorTypes = {
  select: 'select',
  meter: 'meter',
}
